import Grid, { GridSize } from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {
  IJobMatching,
  MatchingValues,
} from '@orientaction/components/Form/CreateEditAdmin/Job/type';
import { FC, ReactNode, SVGProps, useEffect, useState } from 'react';
import { useStyles } from './style';

interface IdetailJobMatchingProps {
  Icon: FC<SVGProps<SVGSVGElement>>;
  title: string;
  job: IJobMatching;
  color: string;
  id: keyof MatchingValues;
  tableRowCount: GridSize;
  keys: string[];
  children?: ReactNode;
  subtitle?: string;
}
const MatchingTableFooterRow = ({ title, value }: { title: string; value: string }) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        item={true}
        xs={6}
        style={{
          borderBottomLeftRadius: 5,
          borderBottom: '1px dashed #5E65A3',
          borderLeft: '1px dashed #5E65A3',
          borderRight: '1px dashed #5E65A3',
        }}>
        <div>
          <Typography variant="h6" className={classes.cellule}>
            {title}
          </Typography>
        </div>
      </Grid>
      <Grid
        item={true}
        xs={6}
        style={{
          borderBottomRightRadius: 5,
          borderBottom: '1px dashed #5E65A3',
          borderRight: '1px dashed #5E65A3',
        }}>
        <div>
          <Typography variant="h6" className={classes.celluleMatch}>
            {value}
          </Typography>
        </div>
      </Grid>
    </>
  );
};

const MatchingTableHeadRow = ({ title, value }: { title: string; value: string }) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        item={true}
        xs={6}
        style={{
          borderTopLeftRadius: 5,
          borderTop: '1px dashed #5E65A3',
          borderLeft: '1px dashed #5E65A3',
          borderBottom: '1px dashed #5E65A3',
          borderRight: '1px dashed #5E65A3',
        }}>
        <div>
          <Typography variant="h6" className={classes.cellule}>
            {title}
          </Typography>
        </div>
      </Grid>
      <Grid
        item={true}
        xs={6}
        style={{
          borderTopRightRadius: 5,
          borderTop: '1px dashed #5E65A3',
          borderBottom: '1px dashed #5E65A3',
          borderRight: '1px dashed #5E65A3',
        }}>
        <div>
          <Typography variant="h6" className={classes.celluleMatch}>
            {value}
          </Typography>
        </div>
      </Grid>
    </>
  );
};
const MatchingTableRow = ({ title, value }: { title: string; value: string }) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        item={true}
        xs={6}
        style={{
          borderBottom: '1px dashed #5E65A3',
          borderRight: '1px dashed #5E65A3',
          borderLeft: '1px dashed #5E65A3',
        }}>
        <div>
          <Typography variant="h6" className={classes.cellule}>
            {title}
          </Typography>
        </div>
      </Grid>
      <Grid
        item={true}
        xs={6}
        style={{ borderBottom: '1px dashed #5E65A3', borderRight: '1px dashed #5E65A3' }}>
        <div>
          <Typography variant="h6" className={classes.celluleMatch}>
            {value}
          </Typography>
        </div>
      </Grid>
    </>
  );
};
const MatchingTable = ({ object }: { object: { [key: string]: string } }) => {
  const [items, setItems] = useState<Array<{ title: string; value: string }>>();
  useEffect(() => {
    if (object) {
      const arr = Object.keys(object).map(k => ({ title: k, value: object[k] }));
      setItems(arr);
    }
  }, [object]);
  return (
    <Grid style={{ marginTop: 20 }} container={true} item={true}>
      {items?.map((item, index) => {
        if (index === 0)
          return <MatchingTableHeadRow key={item.title} title={item.title} value={item.value} />;
        if (index === items.length - 1)
          return <MatchingTableFooterRow key={item.title} title={item.title} value={item.value} />;
        return <MatchingTableRow key={item.title} title={item.title} value={item.value} />;
      })}
    </Grid>
  );
};

const DetailJobMatching = ({
  Icon,
  title,
  job,
  id,
  color,
  keys,
  tableRowCount = 'auto',
  subtitle,
  children,
}: IdetailJobMatchingProps) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.containerMatch}>
        <Grid container={true} alignItems="center" justifyContent="space-between">
          <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
            <Icon style={{ width: 30, height: 33, marginRight: 15 }} />
            <Typography className={classes.matchTitle} style={{ color }}>
              Matching <span>{title}</span>
            </Typography>
          </Grid>
        </Grid>
        {/* Les figures du destin */}
        <Grid
          style={{ marginTop: 20 }}
          container={true}
          alignItems="center"
          justifyContent="space-between">
          {subtitle && (
            <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
              <Typography className={classes.titleTable}>{subtitle}</Typography>
            </Grid>
          )}
        </Grid>
        <Grid container={true} justifyContent="space-between" spacing={2}>
          {!!job[id] &&
            keys.map(k => (
              <Grid item={true} key={k} xs={tableRowCount}>
                <MatchingTable object={(job[id] as any)[k]} />
              </Grid>
            ))}
        </Grid>
        {children}
      </div>
    </>
  );
};

export default DetailJobMatching;
